import React, { useEffect, useState } from 'react';
import HeaderBar from './components/HeaderBar';
import Dashboard from './components/Dashboard';
import ModelSquare from './components/ModelSquare';
import LogsTable from './components/LogsTable';
import { API } from './helpers';
import './App.css';
import './whale.css';

function App() {
  const [page, setPage] = useState('console');
  const [systemName, setSystemName] = useState('砂糖酒馆');

  useEffect(() => {
    API.get('/remote-api/api/status')
      .then((res) => {
        const data = res?.data?.data || res?.data || {};
        if (data.system_name) setSystemName(data.system_name);
      })
      .catch(() => {});
  }, []);

  return (
    <div className="w-app-root">
      <div className="w-shell">
        <HeaderBar page={page} onNavigate={setPage} systemName={systemName} />
        <div className="w-page active w-page-body">
          {page === 'console' && (
            <div className="w-console w-console-b-side">
              <div className="w-console-layout is-b-side">
                <div className="w-console-main-col">
                  <div className="w-query-main layout-b-side">
                    <LogsTable layout="b-side" />
                  </div>
                </div>
                <aside className="w-console-side-col">
                  <Dashboard page="home" onOpenPage={setPage} variant="rail" />
                </aside>
              </div>
            </div>
          )}
          {page === 'models' && <ModelSquare />}
          {(page === 'notice' || page === 'contact' || page === 'tavern-free' || page === 'tavern-buy') && (
            <Dashboard page={page} onOpenPage={setPage} />
          )}
        </div>
        <div className="w-footer">{systemName} · 令牌查询</div>
      </div>
    </div>
  );
}

export default App;
